import React, { useState, useEffect } from 'react';
import { publicAPI } from '../../services/api';
import { FiFacebook, FiInstagram, FiYoutube } from 'react-icons/fi';
import { FaTiktok } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const [footerBg, setFooterBg] = useState(null);
  const [instagramReels, setInstagramReels] = useState([]);
  // Inicializamos con valores por defecto para asegurar que los iconos se vean
  const [config, setConfig] = useState({
    facebook_url: 'https://facebook.com',
    instagram_url: 'https://instagram.com',
    youtube_url: 'https://youtube.com',
    tiktok_url: ''
  });

  useEffect(() => {
    Promise.all([
      publicAPI.getFooterImages(),
      publicAPI.getInstagramReels(),
      publicAPI.getConfiguration(),
    ])
      .then(([footerResponse, reelsResponse, configResponse]) => {
        if (footerResponse.data && footerResponse.data.length > 0) {
          // Usamos la primera imagen activa como fondo
          setFooterBg(footerResponse.data[0].file_path);
        }
        setInstagramReels(reelsResponse.data);
        // Actualizamos con los datos del backend, manteniendo defaults si faltan campos
        if (configResponse.data) {
          setConfig(prev => ({ ...prev, ...configResponse.data }));
        }
      })
      .catch((error) => {
        console.error('Error loading footer data:', error);
      });
  }, []);

  useEffect(() => {
    if (instagramReels.length > 0) {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      } else {
        const scriptId = 'instagram-embed-script';
        if (!document.getElementById(scriptId)) {
          const script = document.createElement('script');
          script.id = scriptId;
          script.src = '//www.instagram.com/embed.js';
          script.async = true;
          document.body.appendChild(script);
        }
      }
    }
  }, [instagramReels]);

  return (
    <footer className="footer" style={{ backgroundImage: footerBg ? `url(${footerBg})` : 'none' }}>
      <div className="footer-content"> {/* Este div ahora tiene el overlay via CSS */}
        <div className="container">
          {/* Instagram Reels Section */}
          {instagramReels.length > 0 && (
            <section className="instagram-section">
              <h3>Reels de Instagram</h3>
              <div className="reels-container">
                {instagramReels.map((reel) => (
                  <div
                    key={reel.id}
                    className="reel-item"
                    dangerouslySetInnerHTML={{ __html: reel.embed_code }}
                  />
                ))}
              </div>
            </section>
          )}

          {/* Social Media Links */}
          <section className="social-section">
            <h3>Síguenos</h3>
            <div className="social-links">
              {config.facebook_url && (
                <a
                  href={config.facebook_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <FiFacebook />
                </a>
              )}
              {config.instagram_url && (
                <a
                  href={config.instagram_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <FiInstagram />
                </a>
              )}
              {config.youtube_url && (
                <a
                  href={config.youtube_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <FiYoutube />
                </a>
              )}
              {config.tiktok_url && (
                <a
                  href={config.tiktok_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="TikTok"
                >
                  <FaTiktok />
                </a>
              )}
            </div>
          </section>

          {/* Copyright */}
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Sitio Web Realizado por Integra C.A telf. 04122552490 -- IMDI. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
